import React from 'react';
import slug from 'slug';
import {Link} from 'react-router';
import {Scrollbars} from 'react-custom-scrollbars';

import './SurgeryContent.scss';

class SurgeryContent extends React.PureComponent {
  renderProcedures = () => {
    const surgery = this.props.langs.surgery;
    const slugSurgery = slug(surgery.name, {lower: true});

    return surgery.procedures.map(procedure => {
      const slugProcedure = slug(procedure.name, {lower: true});

      return (
        <li key={procedure.id}>
          <Link to={`/zakrok/${slugSurgery}/${slugProcedure}`}>
            {procedure.name}
          </Link>
        </li>
      )
    })
  };

  render() {
    const surgery = this.props.langs.surgery;

    return (
      <section className="surgeryContent">
        <Scrollbars className="hidden-xs">
          <div className="surgeryContent_container">
            <h2 className="line surgeryContent_title"> {surgery.id === 2 ? "Laserová a estetická medicína" : surgery.name}</h2>
            <ul className="ul">
              {this.renderProcedures()}
            </ul>
          </div>
        </Scrollbars>

        <div className="surgeryContent_container visible-xs">
          <h2 className="line surgeryContent_title"> {surgery.id === 2 ? "Laserová a estetická medicína" : surgery.name}</h2>
          <ul className="ul">
            {this.renderProcedures()}
          </ul>
        </div>
      </section>
    );
  }
}

export default SurgeryContent;


// WEBPACK FOOTER //
// ./src/components/Surgery/SurgeryContent/SurgeryContent.js